import { PaperClipIcon } from '@heroicons/react/20/solid'
import { useState, useEffect } from "react";
// import { useRouter } from 'next/router';
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowPathIcon, PencilIcon } from "@heroicons/react/24/outline";
import { useStore } from "../../../store";
import Loader from "../../../components/atoms/loader";
import FileViewer from "../../../components/atoms/fileViewer";

const ViewEmployee = () => {
    const navigate = useNavigate();
    // const router = useRouter();
    const location = useLocation();
    const { employeeStore } = useStore();
    const uid = location.pathname.split("/").pop();
    const [loading, setLoading] = useState(true);
    const [employee, setEmployee] = useState({});
    const [urlVal, setUrlVal] = useState("")
    const [open, setOpen] = useState(false)
    useEffect(() => {
        employeeStore.getEmployeeInfo(uid).then((response) => {
            if (response.error) {
                navigate("/404");
            }
            setEmployee(response.data);
            setLoading(false);
        });
    }, []);
    const goBackButton = () => {
        // router.back()
        navigate('/employees')
    }

    return (
        <>
            {loading && <Loader />}
            <button
                type="button"
                onClick={goBackButton}
                className="mb-6 inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Back
            </button>
            <div className="overflow-hidden bg-white shadow sm:rounded-lg">
                {/* Header */}
                <div className="px-4 py-5 sm:px-6">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">{employee.name}
                        <button
                            type="button"
                            onClick={() => window.location.reload(false)}
                            className="inline-flex items-center rounded border border-gray-300 bg-white ml-2 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            <ArrowPathIcon className="h-3 w-3 text-gray-500" aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate(`/employees/edit/${uid}`)}
                            className="inline-flex items-center rounded border border-gray-300 bg-white ml-2 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            <PencilIcon className="h-3 w-3 text-gray-500" aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate(`/employees/history/${uid}`)}
                            className="inline-flex items-center rounded border border-gray-300 bg-white ml-2 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            View Historical Data
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate(`/employees/history-leave-settings/${uid}`)}
                            className="inline-flex items-center rounded border border-gray-300 bg-white ml-2 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            View Historical Leave Settings
                        </button>
                    </h3>
                    <p className="text-sm font-medium text-gray-500 mt-1">
                        {employee.designation} &middot; {employee.department}
                    </p>
                </div>
                {/* Body */}
                <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
                    <dl className="sm:divide-y sm:divide-gray-200">
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Profile Image</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                <div className='w-32 h-32'>
                                    {employee?.imageProfile ?
                                        <img src={employee?.imageProfile || "/avatar.png"} alt="imageProfile" className="rounded-lg" />
                                        : <img src='/avatar.png' alt="imageProfile" className="rounded-lg" />
                                    }
                                </div>
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Official Email</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                <a href={`mailto:${employee.email}`} className="font-medium text-blue-600 hover:text-blue-500">
                                    {employee.email}
                                </a>
                            </dd>
                        </div>

                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Phone Number</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                <a href={`tel:${employee.phone}`} className="font-medium text-blue-600 hover:text-blue-500">
                                    {employee.phone}
                                </a>
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Alternative Phone Numbers</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                {employee.alternatePhone && employee.alternatePhone.split(",").map((phone, index) => {
                                    return <div
                                        key={index}
                                    ><a

                                        className="underline" href={`tel:${phone}`}>{phone}</a><br />
                                    </div>
                                })}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Personal Email</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                <a href={`mailto:${employee.personalEmail}`} className="font-medium text-blue-600 hover:text-blue-500">
                                    {employee.personalEmail}
                                </a>
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Address</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                {employee.address}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Work Location</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                {employee.workLocation}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Salary</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 firstlettercaps">
                                {employee.salary} / {employee.paidPer}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">National Insurance Number</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                {employee.niNum}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Source Of Hiring</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                {employee.sourceOfHiring}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Citizenship</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                {employee.citizenship}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Is Sponsored Migrant</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 firstlettercaps">
                                {employee.isSponsored}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Date Of Birth</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                {new Date(employee.dob).toLocaleDateString()}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Job Start Date</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                {new Date(employee.jobStartDate).toLocaleDateString()}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Type of Visa</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 firstlettercaps">
                                {employee.typeOfVisa ? employee.typeOfVisa?.charAt(0).toUpperCase() + employee.typeOfVisa?.replace(/([A-Z])/g, ' $1').trim().slice(1) : ""}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Visa Expires Date</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                {employee.visaExpiresDate ? new Date(employee.visaExpiresDate).toLocaleDateString() : ""}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Additional Notes</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 overflow-x-auto w-96">
                                {employee.additionalNotes}
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Employment  Contract</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                <ul role="list" className="divide-y divide-gray-200 rounded-md border border-gray-200">
                                    {employee.employementContract && employee.employementContract.map((contract, index) => (
                                        <li className="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                                            <div className="flex w-0 flex-1 items-center">
                                                <PaperClipIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                                <span className="ml-2 w-0 flex-1 truncate">
                                                    {contract.split("/").pop()}
                                                </span>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <p onClick={() => { setUrlVal(contract); setOpen(true) }} className="cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                                                    View
                                                </p>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <a href={contract} target="_blank" className="font-medium text-indigo-600 hover:text-indigo-500">
                                                    Download
                                                </a>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Skill Qualification</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                <ul role="list" className="divide-y divide-gray-200 rounded-md border border-gray-200">
                                    {employee.skillQualification && employee.skillQualification.map((contract, index) => (
                                        <li className="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                                            <div className="flex w-0 flex-1 items-center">
                                                <PaperClipIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                                <span className="ml-2 w-0 flex-1 truncate">
                                                    {contract.split("/").pop()}
                                                </span>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <p onClick={() => { setUrlVal(contract); setOpen(true) }} className="cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                                                    View
                                                </p>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <a href={contract} target="_blank" className="font-medium text-indigo-600 hover:text-indigo-500">
                                                    Download
                                                </a>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Recruitment Process</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                <ul role="list" className="divide-y divide-gray-200 rounded-md border border-gray-200">
                                    {employee.recruitmentProcess && employee.recruitmentProcess.map((contract, index) => (
                                        <li className="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                                            <div className="flex w-0 flex-1 items-center">
                                                <PaperClipIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                                <span className="ml-2 w-0 flex-1 truncate">
                                                    {contract.split("/").pop()}
                                                </span>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <p onClick={() => { setUrlVal(contract); setOpen(true) }} className="cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                                                    View
                                                </p>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <a href={contract} target="_blank" className="font-medium text-indigo-600 hover:text-indigo-500">
                                                    Download
                                                </a>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Right To Work</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                <ul role="list" className="divide-y divide-gray-200 rounded-md border border-gray-200">
                                    {employee.rightToWork && employee.rightToWork.map((contract, index) => (
                                        <li className="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                                            <div className="flex w-0 flex-1 items-center">
                                                <PaperClipIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                                <span className="ml-2 w-0 flex-1 truncate">
                                                    {contract.split("/").pop()}
                                                </span>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <p onClick={() => { setUrlVal(contract); setOpen(true) }} className="cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                                                    View
                                                </p>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <a href={contract} target="_blank" className="font-medium text-indigo-600 hover:text-indigo-500">
                                                    Download
                                                </a>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </dd>
                        </div>
                        <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Other Documents</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                <ul role="list" className="divide-y divide-gray-200 rounded-md border border-gray-200">
                                    {employee.otherDocuments && employee.otherDocuments.map((contract, index) => (
                                        <li className="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                                            <div className="flex w-0 flex-1 items-center">
                                                <PaperClipIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                                <span className="ml-2 w-0 flex-1 truncate">
                                                    {contract.split("/").pop()}
                                                </span>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <p onClick={() => { setUrlVal(contract); setOpen(true) }} className="cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                                                    View
                                                </p>
                                            </div>
                                            <div className="ml-4 flex-shrink-0">
                                                <a href={contract} target="_blank" className="font-medium text-indigo-600 hover:text-indigo-500">
                                                    Download
                                                </a>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </dd>
                        </div>
                    </dl>
                </div>
                <FileViewer url={urlVal} setOpen={setOpen} open={open} />
            </div>
        </>
    )

};

export default ViewEmployee;